import type { Currency } from 'types/account';
import type { CostWithCurrency } from 'types/units';

export const ZERO_COST = Object.freeze<CostWithCurrency>({
  formatted: '0',
  amount: 0,
  fractional: 0,
  currency_code: '',
});

/** Subscriptions and add-ons are always billed in USD, whatever the workspace currency is. */
export const USD_CURRENCY = Object.freeze<Currency>({
  id: 'usd',
  name: 'United States Dollar',
  iso_code: 'USD',
  symbol: '$',
  symbol_first: true,
});
